// extracted by mini-css-extract-plugin
export var bet = "styles-module--bet--e86b0";
export var bets = "styles-module--bets--aaf76";
export var coef = "styles-module--coef--9906e";
export var date = "styles-module--date--9ed5a";
export var dates = "styles-module--dates--3592e";
export var flag = "styles-module--flag--ba1ed";
export var group = "styles-module--group--8e108";
export var groupName = "styles-module--groupName--c59fd";
export var header = "styles-module--header--2818c";
export var matchInfo = "styles-module--matchInfo--69985";
export var team = "styles-module--team--7b15b";
export var teamName = "styles-module--teamName--fde5f";
export var time = "styles-module--time--02b6f";
export var vs = "styles-module--vs--51963";
export var widget = "styles-module--widget--21342";